<template>
  <!-- 服务项目招募 -->
  <div class="page-recruit">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" ref="form" :model="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="text" placeholder="请输入">
              <el-input v-model="form.text"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item  class="el-form-state"  label="类型 :" prop="type">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item  class="el-form-state" label="状态 :" prop="status">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-time" label="报名截止时间 :" prop="time">
              <el-date-picker v-model="form.time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content" style="margin-top: 0">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;发布招募活动
          </el-button>
          <!-- <cmpMyExport
            class="ml-20"
            @clearSelectsCall="clearSelectsCall"
            :chooseIds="chooseRowIds"
            :chooseApi="`/scheme/exportScheme?arr=`"
            :searchApi="`/scheme/exportSchemeAll?schemeName=`+form.schemeName+`&schemeNumber=`+form.schemeNumber+`&planYear=`+form.planYear+`&dataState=`+form.dataState"
          ></cmpMyExport>-->
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column> -->
          <!-- <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column> -->
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="serviceName" v-if="serviceType == 2" label="讲解名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="exhibitionName" v-else :label="serviceType == 4 ? '展览名称' : '活动名称'" min-width="10%" show-overflow-tooltip></el-table-column>

          <el-table-column v-if="serviceType == 2" label="招募类型" min-width="10%">
            <template slot-scope="scope">
              <span  style="text-overflow: initial;">{{scope.row.recruitmentType | filterRecruitmentType(that)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="招募状态" min-width="7%">
            <template slot-scope="scope">
              <span  style="text-overflow: initial;">{{scope.row.status | filterStatus(that)}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="exhibitionName" v-if="serviceType == 2" label="展览名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="serviceLocation" :label="serviceType == 2 || serviceType == 4? '展厅位置': '活动地点'" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column label="服务时间" min-width="21%">
            <template slot-scope="scope">
              <span>{{scope.row.serviceTimeBegin}}～{{scope.row.serviceTimeEnd}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="explainNum" v-if="serviceType == 4" label="要求场次" min-width="10%" show-overflow-tooltip></el-table-column>

          <el-table-column v-if="serviceType != 4" :label="serviceType == 2? '讲解时长' : '活动时长'" min-width="7%">
            <template slot-scope="scope">
              <span>{{scope.row.serviceDuration || 0}}小时</span>
            </template>
          </el-table-column>
          <el-table-column prop="quota" label="招募名额" min-width="7%"></el-table-column>
          <el-table-column prop="quotaAlready" label="已报名" min-width="7%"></el-table-column>
          <el-table-column prop="deadlineTime" label="报名截止" min-width="10%">
            <template slot-scope="scope">
              <span v-if="scope.row.deadlineTime">{{$common.formatDateString(scope.row.deadlineTime, 'yyyy-MM-dd hh:mm')}}</span>
            </template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="16%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" v-if="scope.row.status == 0" @click="handlePublish(scope.row)">发布</a>
              <a class="m-btn mr-10" @click="handleAdd('detail', scope.row.id)">查看</a>
              <!-- v-if="scope.row.status == 0" -->
              <a class="m-btn mr-10"  @click="handleAdd('edit', scope.row.id)">编辑</a>
              <a class="m-btn mr-10 m-danger"   v-if="scope.row.status == 0"  @click="handleDelete(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogAddRecruit ref="dialogAddRecruit" @refresh="restList"></dialogAddRecruit>
    <dialogActivityInfo ref="dialogActivityInfo" @refresh="restList"></dialogActivityInfo>
    <dialogSetDays ref="dialogSetDays" @refresh="initList"></dialogSetDays>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogAddRecruit from './dialog-add-recruit'
import dialogActivityInfo from './dialog-activity-info'
import dialogSetDays from './dialog-set-days'
export default {
  components: {
    cmpMyExport,
    dialogAddRecruit,
    dialogActivityInfo,
    dialogSetDays
  },
  props: ['serviceType'],
  watch: {
    serviceType: {
      handler(newV, oldV) {
        if (newV == 2 || newV == 4) {
          this.typeList = [{ dictCode: '1', dictName: '正式志愿者' }, { dictCode: '2', dictName: '预备志愿者' }]
        } else if (newV == 3) {
          this.typeList = [{ dictCode: '3', dictName: '学生志愿者' }, { dictCode: '4', dictName: '小志愿者' }, { dictCode: '5', dictName: '社会志愿者' }]
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      that: this,
      form: {
        text: '',
        time: '',
        type: '', //	活动类型
        status: '' //	活动状态
      },
      typeList: [],
      statusList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      chooseRowIds: '' // 当前导出选中藏品id
    }
  },
  filters: {
    filterRecruitmentType(type, self) {
      let arr = type.split(','), name = []
      self.typeList.map(item => {
        arr.map(it => {
          if (it == item.dictCode) {
            name.push(item.dictName)
          }
        })
      })

      if (name && name.length > 0) {
        return name.join(',')
      }

      return null
    },

    filterStatus(type, self) {
      let obj = self.statusList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.$api.volunteer.getVolunteerRecruitList({
        ...this.listQuery,
        serviceType: this.serviceType,
        ...this.form
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_recruit_type', 'volunteer_recruit_status']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            // this.typeList = state['volunteer_recruit_type']
            this.statusList = state['volunteer_recruit_status']
          }
        })
    },

    // handleClickNav(item) {
    //   this.activeNav = item
    //   this.getTableList()
    // },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 发布
    handlePublish(item) {
      this.$http
        .get('/v2/bsVolunteerV2Recruit/publish', {
          id: item.id,
        })
        .then(res => {
          if (res.success) {
            this.$message.success('发布成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '您正在删除服务项目，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer.deleteVolunteerRecruit({ id }).then(res => {
            if (res.success) {
              this.$message.success('服务项目删除成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 新增
    handleAdd(type, id) {
      if (type === 'detail') {
        this.$router.push({
          path: '/volunteer/recruit/detail',
          query: {
            id: id,
            serviceType: this.serviceType
          }
        })
      } else {
        this.$refs.dialogAddRecruit.init(type, id, this.serviceType)
      }
    },
    // 资料管理
    handleShowInfo(id) {
      this.$refs.dialogActivityInfo.init(id)
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.schemeId)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    },

    keydown(event){
      if(event.keyCode == '13'){
        this.getTableList()
      }
    }
  },
  created() {
    this.initList()
    this.getDropdownValue()

    window.addEventListener('keyup',this.keydown)
  }
}
</script>

<style lang="scss" scoped>
.el-form-state{
  /deep/ .el-form-item__label{
    width: 60px !important;
  }
}

.el-form-time{
  /deep/ .el-form-item__label{
    width: 120px !important;
  }
  /deep/ .el-form-item__content{
    margin-left: 120px !important;
  }
}
</style>